/* eslint-disable jsx-a11y/img-redundant-alt */
import { getAddressApi, getEmployeeDetailApi, getEmployeeSalaryDetailApi } from "api/services/employee";
import Breadcrumbs from "components/Breadcrumbs";
import FilterSelect from "components/Form/filterSelect";
import Image from "components/Image";
import ChangePictureModal from "components/modelpopup/EmployeePictureModal";
import { SkeltonLoader } from "components/skeltonLoader";
import { useContext, useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { formatDateHandler2, renderEventStatus, toTitleCase } from "utils/common";
import { EmployeeContext as EmployeeContextFromDirectory } from "../../CompanyDirectory/context/directoryContext";
import { EmployeeContext as EmployeeContextFromEmployees } from "./../context/employeeContext";
import ProfileTab from "./EmployeeProfileTab";

const Profile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  // Add this to extract the profile parameter from the URL
  const searchParams = new URLSearchParams(location.search);
  const isProfileView = searchParams.get('profile') === 'true';

  // Detect if we're on company-directory route
  const isCompanyDirectory = location.pathname.includes('/company-directory');
  const basePath = isCompanyDirectory ? '/company-directory' : '/employees';

  const {
    userData : userDataList, 
    userDataLoading,
  } = useSelector((state) => state.common);
const {
  user,
  userLoading
} = useSelector((state) => state.user);
  
  // Use the appropriate context based on the route
  // Try to get context from both and use whichever is available
  const employeeContextValue = useContext(EmployeeContextFromEmployees);
  const directoryContextValue = useContext(EmployeeContextFromDirectory);
  
  // Use the context that's available (not null/undefined)
  // When on company-directory route, prefer directory context, otherwise prefer employee context
  const employeeContext = isCompanyDirectory 
    ? (directoryContextValue || employeeContextValue)
    : (employeeContextValue || directoryContextValue);
  
  const {
    loading,
    employeeData,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleEmployeeDetailPage,
    selectedPage,
  } = employeeContext || {};
  const [userDataOption, setUserDataOption] = useState([]);

  const [userData, setUserData] = useState({});
  const [userSalaryData, setUserSalaryData] = useState({});
  const [pictureModal, setPictureModal] = useState(false);
  const [detailLoading, setDetailLoading] = useState(true);
  const [detailError, setDetailError] = useState(null);

  const [addresses, setAddresses] = useState([]);
  const [addressLoading, setAddressLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  useEffect(()=>{
   
    let _userData = userDataList?.map(item => {
      return {
        label: ` ${item.emp_no} - ${item.first_name} ${item.middle_name||""} ${item.last_name}`,

          value: item.id
      };
  });
  

    setUserDataOption(_userData)  

},[userDataList])




  // ✅ Fetch addresses from API
  const fetchAddresses = async () => {
    setAddressLoading(true);
    try {
      const response = await getAddressApi({company_user: params?.id});
      setAddresses(response.data?.results); // ✅ Update state with API response
    } catch (error) {
      console.error("Error fetching addresses:", error);
    } finally {
      setAddressLoading(false);
    }
  };

  const fetchDetail = () => {
    setDetailLoading(true);
    setDetailError(null);
    getEmployeeDetailApi(params?.id).then((response) => {
      console.log(response, "REEEEEEE");
      setUserData(response.data);
      setDetailLoading(false);
    }).catch(error => {
      console.error("Error fetching employee details:", error);
      setUserData({});
      setUserSalaryData({});
      setDetailError(error?.response?.status === 404 ? "not_found" : "error");
      setDetailLoading(false);
    });
  }

  useEffect(() => {
    console.log(location, navigate, params, "LLL");
    if (params?.id) {
      fetchDetail()

      getEmployeeSalaryDetailApi(params?.id).then((response) => {
        console.log(response, "SALARY DATAAAAAA");
        setUserSalaryData(response.data)
      }).catch(()=> {
        setUserSalaryData({});
      })
    }
    fetchAddresses();

    // Initialize Bootstrap tabs and set Profile as active on mount
    const initTabs = () => {
      // Set Profile tab as active
      const profileTabs = document.querySelectorAll('[data-bs-toggle="tab"][href="#emp_profile"]');
      profileTabs.forEach(tab => {
        tab.classList.add('active');
      });
      
      // Remove active from other tabs
      document.querySelectorAll('[data-bs-toggle="tab"]').forEach(tab => {
        if (tab.getAttribute('href') !== '#emp_profile') {
          tab.classList.remove('active');
        }
      });
    };
    
    // Initialize after DOM is ready
    if (typeof window !== 'undefined') {
      setTimeout(initTabs, 50);
      // Also listen for tab changes to update active state
      const handleTabShown = (e) => {
        // Remove active from all tabs
        document.querySelectorAll('[data-bs-toggle="tab"]').forEach(tab => {
          tab.classList.remove('active');
        });
        // Add active to the clicked tab
        if (e.target && e.target.hasAttribute('data-bs-toggle')) {
          e.target.classList.add('active');
        }
      };
      
      document.addEventListener('shown.bs.tab', handleTabShown);
      return () => {
        document.removeEventListener('shown.bs.tab', handleTabShown);
      };
    }
  }, [params?.id]);
  
  const handleClickGoBack = () => {
    navigate(-1);
  };

  const handleClickNext = () => {
    const nextIndex = getIndex + 1;
    if (nextIndex < pageSettings.total) {
      let nextEmployee = userDataOption[nextIndex];
      if (isCompanyDirectory) {
        navigate(`${basePath}/${nextEmployee.value}`);
      } else {
        handleEmployeeDetailPage(nextEmployee.value, nextIndex);
      }
    }
  };

  const handleClickPrevious = () => {
    const prevIndex = getIndex - 1;
    if (prevIndex >= 0) {
      let nextEmployee = userDataOption[prevIndex];
      if (isCompanyDirectory) {
        navigate(`${basePath}/${nextEmployee.value}`);
      } else {
        handleEmployeeDetailPage(nextEmployee.value, prevIndex);
      }
    }
  };

  const changeImage = (image) => {
    let _user = {...userData}
    _user['profile_image'] = image
    setUserData(_user)
  }

  const getIndex = useMemo(()=>{

    const index = userDataOption.findIndex(user => user.value === userData.id);
    return index
    
  },[userData])

  const showReportTo = useMemo(()=>{
    const manager = userData?.employment?.report_to;
    const hasAccess = manager?.id && userDataOption.some(u => u.value === manager.id);
    if (hasAccess) {
      return (
        <Link to={`${basePath}/${manager.id}`}>
          {manager.first_name} {manager.last_name}
        </Link>
      );
    }
    if (manager?.first_name || manager?.last_name) {
      return (
        <p>
          {manager?.first_name} {manager?.last_name}
        </p>
      );
    }
    return null;
  },[userData, basePath, userDataOption])

  const allowedEmployeeIds = useMemo(() => userDataList?.map(u => u.id) || [], [userDataList]);

  // Render full-page error when data failed to load
  if (!detailLoading && detailError) {
    const title = detailError === "not_found" ? "Employee not found or access denied." : "Unable to load employee details.";
    const subtitle = "Try searching another employee or return to the listing.";

    return (
      <div className="page-wrapper" style={isMobile ? { height: "100vh", overflow: "hidden" } : {}}>
        <div className="content container-fluid" style={isMobile ? { height: "100%", overflowY: "auto", padding: "0" } : {}}>
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "85vh", padding: isMobile ? "12px" : "24px" }}>
            <div
              className="card shadow-sm"
              style={{
                maxWidth: "620px",
                width: "100%",
                border: "none",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #fff7f7 0%, #ffffff 100%)"
              }}
            >
              <div className="card-body" style={{ padding: isMobile ? "20px" : "32px" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", gap: "12px" }}>
                  <div
                    style={{
                      width: "72px",
                      height: "72px",
                      borderRadius: "16px",
                      background: "#fff1f2",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#d3001a",
                      boxShadow: "0 8px 24px rgba(211, 0, 26, 0.12)"
                    }}
                  >
                    <i className="las la-exclamation-triangle" style={{ fontSize: "32px" }} />
                  </div>
                  <div>
                    <h4 style={{ margin: "0 0 8px 0", color: "#111827" }}>{title}</h4>
                    <p style={{ margin: 0, color: "#6b7280" }}>{subtitle}</p>
                  </div>
                  <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", justifyContent: "center", marginTop: "6px" }}>
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={handleClickGoBack}
                    >
                      Go Back
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => navigate("/employees")}
                      style={{ backgroundColor: "rgb(211, 0, 26)", borderColor: "rgb(211, 0, 26)" }}
                    >
                      Employee Listing
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <style>{`
        @media (max-width: 767px) {
          .page-wrapper {
            height: 100vh;
            overflow: hidden;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
          }
          .content.container-fluid {
            height: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            -webkit-overflow-scrolling: touch;
            padding: 0;
            background: #f9fafb;
          }
          .tab-content {
            padding-bottom: 0;
          }
          .tab-pane {
            padding-bottom: 160px !important;
          }
          @supports (padding: max(0px)) {
            .tab-pane {
              padding-bottom: max(160px, calc(140px + env(safe-area-inset-bottom))) !important;
            }
          }
          .tab-pane .row:last-child {
            margin-bottom: 30px !important;
          }
          .tab-pane .row:last-child .card {
            margin-bottom: 30px !important;
          }
          .card {
            border-radius: 0 !important;
            border: none !important;
          }
          .card-body {
            border: none !important;
          }
        }
        .nav-tabs {
          border-bottom: 2px solid #e5e7eb !important;
        }
        .nav-tabs .nav-link.active {
          color: rgb(211, 0, 26) !important;
          border-bottom: 3px solid rgb(211, 0, 26) !important;
          background: transparent !important;
        }
        .nav-tabs .nav-link:not(.active) {
          color: #6b7280 !important;
          background: transparent !important;
          border-bottom: 3px solid transparent !important;
        }
        .nav-tabs .nav-link {
          transition: all 0.2s ease;
        }
        .nav-tabs .nav-link:hover:not(.active) {
          color: rgb(211, 0, 26) !important;
          background: transparent !important;
        }
      `}</style>
       <div className="page-wrapper" style={isMobile ? { height: "100vh", overflow: "hidden" } : {}}>
         <div className="content container-fluid" style={isMobile ? { 
           height: "100%", 
           overflowY: "auto", 
           overflowX: "hidden",
           padding: "0 8px"
         } : {}}>
          
          {/* Only show breadcrumbs if not in profile view */}
          {!isProfileView && !isMobile && (
            <Breadcrumbs
              maintitle="Profile"
              title="Employee"
              subtitle="Profile Detail"
              modal="#add_indicator"
              name="Add New"
              showModal={false}
              linkName="/employees"
            />
          )}
          
          {/* Search user - show for both mobile and desktop */}
          {!isProfileView && (
            <div style={{ 
              marginBottom: isMobile ? "12px" : "0", 
              marginTop: isMobile ? "12px" : "0",
              padding: isMobile ? "0 8px" : "0" 
            }}>
              <div className={isMobile ? "col-12" : "col-md-3 mb-2"}>
                <FilterSelect 
                  placeholder={"Search user"} 
                  options={userDataOption} 
                  loading={userDataLoading}
                  onChange={e => {
                    console.log(e, "EE")
                    navigate(`${basePath}/${e.value}`)
                  }} 
                  optionLabel={"label"} 
                  optionValue={'value'}
                />
              </div>
            </div>
          )}

          {/* Desktop Navigation */}
          {!isMobile && (
            <div>
              <div className="contact-head">
                <div className="row align-items-center">
                  <div className="col-sm-6">
                    {!isProfileView && (
                      <ul className="contact-breadcrumb">
                        <li>
                          <Link to="#" onClick={handleClickGoBack}>
                            <i className="las la-arrow-left" /> Employee
                          </Link>
                        </li>
                        <li>
                          {userData?.first_name} {userData?.last_name}
                        </li>
                      </ul>
                    )}
                  </div>
                  <div className="col-sm-6 text-sm-end">
                    {!isProfileView && (
                      <div className="contact-pagination">
                        <p>
                          {getIndex+1} of {pageSettings.total}
                        </p>
                        <ul>
                          <li>
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                handleClickPrevious();
                              }}
                            >
                              <i className="las la-arrow-left" />
                            </Link>
                          </li>
                          <li>
                            <Link
                              onClick={(e) => {
                                e.preventDefault();
                                handleClickNext();
                              }}
                            >
                              <i className="las la-arrow-right" />
                            </Link>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Mobile Pagination Controls */}
          {isMobile && !isProfileView && (
            <div style={{
              padding: "12px 16px",
              background: "#ffffff",
              borderBottom: "1px solid #e5e7eb",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}>
              <button
                onClick={handleClickPrevious}
                disabled={getIndex === 0}
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: "1px solid #e5e7eb",
                  background: getIndex === 0 ? "#f3f4f6" : "#ffffff",
                  color: getIndex === 0 ? "#9ca3af" : "#1f2937",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: getIndex === 0 ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px"
                }}
              >
                <i className="las la-arrow-left" />
                Previous
              </button>
              <span style={{ fontSize: "13px", color: "#6b7280", fontWeight: "500" }}>
                {getIndex+1} / {pageSettings.total}
              </span>
              <button
                onClick={handleClickNext}
                disabled={getIndex+1 >= pageSettings.total}
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: "1px solid #e5e7eb",
                  background: getIndex+1 >= pageSettings.total ? "#f3f4f6" : "#ffffff",
                  color: getIndex+1 >= pageSettings.total ? "#9ca3af" : "#1f2937",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: getIndex+1 >= pageSettings.total ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px"
                }}
              >
                Next
                <i className="las la-arrow-right" />
              </button>
            </div>
          )}

          <div className="card shadow-sm" style={{ 
            borderRadius: "8px", 
            border: "none",
            background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
            marginBottom: isMobile ? "12px" : "16px",
            marginTop: isMobile ? "12px" : "0",
            marginLeft: isMobile ? "8px" : "0px",
            marginRight: isMobile ? "8px" : "0px",
            boxShadow: isMobile ? "0 2px 8px rgba(0,0,0,0.1)" : "0 4px 20px rgba(0,0,0,0.08)",
            overflow: "hidden"
          }}>
            <div className="card-body" style={{ padding: isMobile ? "16px 12px" : "20px", border: "none" }}>
              {detailLoading ? (
                <div className="d-flex flex-column align-items-center" style={{ padding: isMobile ? "20px 0" : "0" }}>
                  <SkeltonLoader number={1} active={true} style={{ width: isMobile ? "100px" : "120px", height: isMobile ? "100px" : "120px", borderRadius: '50%' }} />
                  <div className="mt-3 w-100">
                    <SkeltonLoader number={2} active={true} className="mb-2" />
                  </div>
                </div>
              ) : (
                <div className={isMobile ? "d-flex flex-column align-items-center" : "row align-items-center"}>
                  {/* Profile Image */}
                  <div className={isMobile ? "mb-3" : "col-md-3 text-center mb-2 mb-md-0"}>
                    <div style={{ position: "relative", display: "inline-block" }}>
                      <div style={{
                        width: isMobile ? "100px" : "120px",
                        height: isMobile ? "100px" : "120px",
                        borderRadius: "50%",
                        overflow: "hidden",
                        border: userData?.gender?.toLowerCase() === "male" || userData?.gender?.toLowerCase() === "m"
                          ? "2px solid #3b82f6"
                          : userData?.gender?.toLowerCase() === "female" || userData?.gender?.toLowerCase() === "f"
                            ? "2px solid #ec4899"
                            : "2px solid #9ca3af",
                        boxShadow: isMobile 
                          ? "0 8px 24px rgba(0,0,0,0.2)" 
                          : "0 8px 24px rgba(0,0,0,0.15)",
                        background: "#f0f0f0",
                        transition: "transform 0.3s ease",
                        cursor: "pointer"
                      }}
                      onMouseEnter={(e) => {
                        if (!isMobile) e.currentTarget.style.transform = "scale(1.05)";
                      }}
                      onMouseLeave={(e) => {
                        if (!isMobile) e.currentTarget.style.transform = "scale(1)";
                      }}
                      >
                        <Image 
                          src={userData?.profile_image} 
                          type="user" 
                          alt="User Image" 
                          style={{ 
                            objectFit: "cover",
                            width: "100%",
                            height: "100%"
                          }} 
                        />
                      </div>
                      {user?.id == userData.id && (
                        <Link
                          to="#"
                          onClick={() => setPictureModal(true)}
                          className="d-flex justify-content-center align-items-center text-white"
                          style={{
                            borderRadius: "50%",
                            position: "absolute",
                            width: isMobile ? "32px" : "38px",
                            height: isMobile ? "32px" : "38px",
                            bottom: 0,
                            right: 0,
                            background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                            boxShadow: "0 4px 12px rgba(211, 0, 26, 0.4)",
                            border: "3px solid #ffffff",
                            transition: "transform 0.2s ease"
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.1)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                        >
                          <i className="fa fa-pencil" style={{ fontSize: isMobile ? "12px" : "14px" }} />
                        </Link>
                      )}
                    </div>
                  </div>

                  {/* Profile Info */}
                  <div className={isMobile ? "w-100 text-center" : "col-md-9"}>
                    <div className={isMobile ? "" : "d-flex flex-column h-100 justify-content-center"}>
                      <h3 style={{ 
                        fontSize: isMobile ? "20px" : "26px",
                        fontWeight: "400",
                        color: "#1f2937",
                        marginBottom: "4px",
                        lineHeight: "1.3",
                        letterSpacing: "-0.5px"
                      }}>
                        {userData?.first_name} {userData?.middle_name} {userData?.last_name}
                      </h3>
                      <div style={{ 
                        fontSize: isMobile ? "13px" : "14px",
                        color: "#6b7280",
                        marginBottom: "12px",
                        fontWeight: "400"
                      }}>
                        {userData?.employment?.position?.name}
                      </div>
                      
                      {isMobile ? (
                        <div className="row g-2 mt-2" style={{ margin: "0" }}>
                          <div className="col-6">
                            <div style={{
                              background: "#ffffff",
                              borderRadius: "8px",
                              padding: "8px",
                              border: "none",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                              marginBottom: "6px"
                            }}>
                              <div style={{ fontSize: "10px", color: "#6b7280", marginBottom: "3px" }}>Department</div>
                              <div style={{ fontSize: "12px", color: "#1f2937", fontWeight: "400" }}>
                                {userData?.employment?.department?.name}
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div style={{
                              background: "#ffffff",
                              borderRadius: "8px",
                              padding: "8px",
                              border: "none",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                              marginBottom: "6px"
                            }}>
                              <div style={{ fontSize: "10px", color: "#6b7280", marginBottom: "3px" }}>HR Code</div>
                              <div style={{ fontSize: "12px", color: "#1f2937", fontWeight: "400" }}>
                                {userData?.emp_no}
                              </div>
                            </div>
                          </div>
                          {userData?.company_phone_number && (
                            <div className="col-6">
                              <div style={{
                                background: "#ffffff",
                                borderRadius: "8px",
                                padding: "8px",
                                border: "1px solid #e5e7eb",
                                marginBottom: "6px"
                              }}>
                                <div style={{ fontSize: "10px", color: "#6b7280", marginBottom: "3px" }}>Phone</div>
                                <Link 
                                  to={`tel:${userData?.company_phone_number}`}
                                  style={{ fontSize: "12px", color: "rgb(211, 0, 26)", fontWeight: "400", textDecoration: "none" }}
                                >
                                  {userData?.company_phone_number}
                                </Link>
                              </div>
                            </div>
                          )}
                          <div className="col-6">
                            <div style={{
                              background: "#ffffff",
                              borderRadius: "8px",
                              padding: "8px",
                              border: "none",
                              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                              marginBottom: "6px"
                            }}>
                              <div style={{ fontSize: "10px", color: "#6b7280", marginBottom: "3px" }}>Email</div>
                              {userData?.company_email ? (
                                <Link 
                                  to={`mailto:${userData?.company_email}`}
                                  style={{ fontSize: "12px", color: "rgb(211, 0, 26)", fontWeight: "400", textDecoration: "none" }}
                                >
                                  {userData?.company_email}
                                </Link>
                              ) : (
                                <div style={{ fontSize: "12px", color: "#9ca3af", fontWeight: "400" }}>—</div>
                              )}
                            </div>
                          </div>
                          {userData?.birthday && (
                            <div className="col-6">
                              <div style={{
                                background: "#ffffff",
                                borderRadius: "8px",
                                padding: "8px",
                                border: "1px solid #e5e7eb",
                                marginBottom: "6px"
                              }}>
                                <div style={{ fontSize: "10px", color: "#6b7280", marginBottom: "3px" }}>Birthday</div>
                                <div style={{ fontSize: "12px", color: "#1f2937", fontWeight: "400" }}>
                                  {formatDateHandler2(userData?.birthday)}
                                </div>
                              </div>
                            </div>
                          )}
                          {userData?.gender && (
                            <div className="col-6">
                              <div style={{
                                background: "#ffffff",
                                borderRadius: "8px",
                                padding: "8px",
                                border: "1px solid #e5e7eb",
                                marginBottom: "6px"
                              }}>
                                <div style={{ fontSize: "10px", color: "#6b7280", marginBottom: "3px" }}>Gender</div>
                                <div style={{ fontSize: "12px", color: "#1f2937", fontWeight: "400" }}>
                                  {toTitleCase(userData?.gender)}
                                </div>
                              </div>
                            </div>
                          )}
                          {userData?.employment?.report_to && (
                            <div className="col-12">
                              <div style={{
                                background: "#ffffff",
                                borderRadius: "8px",
                                padding: "8px",
                                border: "1px solid #e5e7eb",
                                marginBottom: "6px"
                              }}>
                                <div style={{ fontSize: "10px", color: "#6b7280", marginBottom: "5px", textAlign: "center" }}>Reports To</div>
                                <div className="d-flex align-items-center justify-content-center" style={{ gap: "6px" }}>
                                  <div style={{
                                    width: "24px",
                                    height: "24px",
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                    border: "2px solid #e5e7eb",
                                    flexShrink: 0
                                  }}>
                                    <Image 
                                      src={userData?.employment?.report_to?.profile_image} 
                                      type="user" 
                                      alt="Manager" 
                                      style={{ 
                                        objectFit: "cover",
                                        width: "100%",
                                        height: "100%"
                                      }} 
                                    />
                                  </div>
                                  <Link 
                                    to={`${basePath}/${userData?.employment?.report_to?.id}`}
                                    style={{ fontSize: "12px", color: "rgb(211, 0, 26)", fontWeight: "400", textDecoration: "none" }}
                                  >
                                    {userData?.employment?.report_to?.first_name} {userData?.employment?.report_to?.last_name}
                                  </Link>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="row g-2">
                          {/* Left Side - Employment Details */}
                          <div className="col-md-6">
                            {userData?.employment?.department?.name && (
                              <div className="d-flex align-items-center" style={{ marginBottom: "6px" }}>
                                <i className="las la-building me-2" style={{ fontSize: "16px", color: "#9ca3af", flexShrink: 0, width: "16px" }}></i>
                                <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", flex: 1 }}>
                                  <span style={{ fontSize: "13px", color: "#6b7280", fontWeight: "400", minWidth: "90px", flexShrink: 0 }}>Department:</span>
                                  <span style={{ fontSize: "13px", color: "#1f2937", fontWeight: "400" }}>{userData?.employment?.department?.name}</span>
                                </div>
                              </div>
                            )}
                            {userData?.emp_no && (
                              <div className="d-flex align-items-center" style={{ marginBottom: "6px" }}>
                                <i className="las la-id-card me-2" style={{ fontSize: "16px", color: "#9ca3af", flexShrink: 0, width: "16px" }}></i>
                                <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", flex: 1 }}>
                                  <span style={{ fontSize: "13px", color: "#6b7280", fontWeight: "400", minWidth: "90px", flexShrink: 0 }}>HR Code:</span>
                                  <span style={{ fontSize: "13px", color: "#1f2937", fontWeight: "400" }}>{userData?.emp_no}</span>
                                </div>
                              </div>
                            )}
                            <div className="d-flex align-items-center" style={{ marginBottom: "6px" }}>
                              <i className="las la-calendar me-2" style={{ fontSize: "16px", color: "#9ca3af", flexShrink: 0, width: "16px" }}></i>
                              <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", flex: 1 }}>
                                <span style={{ fontSize: "13px", color: "#6b7280", fontWeight: "400", minWidth: "90px", flexShrink: 0 }}>Join Date:</span>
                                <span style={{ fontSize: "13px", color: "#1f2937", fontWeight: "400" }}>
                                  {formatDateHandler2(userData?.employment?.employment_date)}
                                  {renderEventStatus(userData?.employment?.employment_date, "🎉", "", "bg-success")}
                                </span>
                              </div>
                            </div>
                            {userData?.employment?.report_to && (
                              <div className="d-flex align-items-center">
                                <i className="las la-user me-2" style={{ fontSize: "16px", color: "#9ca3af", flexShrink: 0, width: "16px" }}></i>
                                <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", flex: 1 }}>
                                  <span style={{ fontSize: "13px", color: "#6b7280", fontWeight: "400", minWidth: "90px", flexShrink: 0 }}>Reports To:</span>
                                  <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                    <div style={{
                                      width: "28px",
                                      height: "28px",
                                      borderRadius: "50%",
                                      overflow: "hidden",
                                      border: "2px solid #e5e7eb",
                                      flexShrink: 0
                                    }}>
                                      <Image 
                                        src={userData?.employment?.report_to?.profile_image} 
                                        type="user" 
                                        alt="Manager" 
                                        style={{ 
                                          objectFit: "cover",
                                          width: "100%",
                                          height: "100%"
                                        }} 
                                      />
                                    </div>
                                    <Link 
                                      to={`${basePath}/${userData?.employment?.report_to?.id}`}
                                      style={{ color: "rgb(211, 0, 26)", textDecoration: "none", fontWeight: "400", fontSize: "13px" }}
                                    >
                                      {userData?.employment?.report_to?.first_name} {userData?.employment?.report_to?.last_name}
                                    </Link>
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                          {/* Right Side - Personal Info */}
                          <div className="col-md-6">
                            {userData?.company_phone_number && (
                              <div className="d-flex align-items-center" style={{ marginBottom: "6px" }}>
                                <i className="las la-phone me-2" style={{ fontSize: "16px", color: "#9ca3af", flexShrink: 0, width: "16px" }}></i>
                                <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", flex: 1 }}>
                                  <span style={{ fontSize: "13px", color: "#6b7280", fontWeight: "400", minWidth: "90px", flexShrink: 0 }}>Phone:</span>
                                  <Link to={`tel:${userData?.company_phone_number}`} style={{ fontSize: "13px", color: "rgb(211, 0, 26)", textDecoration: "none", fontWeight: "400" }}>
                                    {userData?.company_phone_number}
                                  </Link>
                                </div>
                              </div>
                            )}
                            <div className="d-flex align-items-center" style={{ marginBottom: "6px" }}>
                              <i className="las la-envelope me-2" style={{ fontSize: "16px", color: "#9ca3af", flexShrink: 0, width: "16px" }}></i>
                              <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", flex: 1 }}>
                                <span style={{ fontSize: "13px", color: "#6b7280", fontWeight: "400", minWidth: "90px", flexShrink: 0 }}>Email:</span>
                                {userData?.company_email ? (
                                  <Link to={`mailto:${userData?.company_email}`} style={{ fontSize: "13px", color: "rgb(211, 0, 26)", textDecoration: "none", fontWeight: "400" }}>
                                    {userData?.company_email}
                                  </Link>
                                ) : (
                                  <span style={{ color: "#9ca3af", fontSize: "13px" }}></span>
                                )}
                              </div>
                            </div>
                            {userData?.birthday && (
                              <div className="d-flex align-items-center" style={{ marginBottom: "6px" }}>
                                <i className="las la-birthday-cake me-2" style={{ fontSize: "16px", color: "#9ca3af", flexShrink: 0, width: "16px" }}></i>
                                <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", flex: 1 }}>
                                  <span style={{ fontSize: "13px", color: "#6b7280", fontWeight: "400", minWidth: "90px", flexShrink: 0 }}>Birthday:</span>
                                  <span style={{ fontSize: "13px", color: "#1f2937", fontWeight: "400" }}>
                                    {formatDateHandler2(userData?.birthday)}
                                    {renderEventStatus(userData?.birthday, "🎂", "Upcoming", "bg-warning")}
                                  </span>
                                </div>
                              </div>
                            )}
                            {userData?.gender && (
                              <div className="d-flex align-items-center">
                                <i className="las la-venus-mars me-2" style={{ fontSize: "16px", color: "#9ca3af", flexShrink: 0, width: "16px" }}></i>
                                <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", flex: 1 }}>
                                  <span style={{ fontSize: "13px", color: "#6b7280", fontWeight: "400", minWidth: "90px", flexShrink: 0 }}>Gender:</span>
                                  <span style={{ fontSize: "13px", color: "#1f2937", fontWeight: "400" }}>{toTitleCase(userData?.gender)}</span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Show skeleton for tabs when loading */}
          {detailLoading ? (
            <div className="card tab-box">
              <div className="row user-tabs">
                <div className="col-lg-12 col-md-12 col-sm-12 line-tabs">
                  <SkeltonLoader number={1} active={true} style={{ height: 40 }} />
                </div>
              </div>
            </div>
          ) : (
            <div className="card shadow-sm mb-3" style={{ 
              borderRadius: isMobile ? "0" : "12px", 
              border: "1px solid #e5e7eb",
              marginBottom: isMobile ? "0" : "16px",
              marginLeft: isMobile ? "8px" : "0px",
              marginRight: isMobile ? "8px" : "0px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              background: "#ffffff",
              overflow: "hidden"
            }}>
              <div className="card-body p-0" style={{ background: "transparent", padding: "0" }}>
                {isMobile ? (
                  <div style={{ 
                    overflowX: "auto",
                    overflowY: "hidden",
                    WebkitOverflowScrolling: "touch",
                    scrollbarWidth: "none",
                    msOverflowStyle: "none"
                  }}>
                    <style>{`
                      .mobile-tabs::-webkit-scrollbar {
                        display: none;
                      }
                      .mobile-tabs {
                        -ms-overflow-style: none;
                        scrollbar-width: none;
                      }
                    `}</style>
                    <ul className="nav nav-tabs mobile-tabs" style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      borderBottom: "2px solid #e5e7eb",
                      padding: "0",
                      margin: 0,
                      minWidth: "max-content",
                      background: "transparent"
                    }}>
                      <li className="nav-item" style={{ flexShrink: 0 }}>
                        <Link
                          to="#emp_profile"
                          data-bs-toggle="tab"
                          className="nav-link active"
                          style={{
                            padding: "14px 20px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "rgb(211, 0, 26)",
                            border: "none",
                            borderBottom: "3px solid rgb(211, 0, 26)",
                            whiteSpace: "nowrap",
                            transition: "all 0.2s ease",
                            background: "transparent",
                            marginBottom: "-2px"
                          }}
                        >
                          Profile
                        </Link>
                      </li>
                      <li className="nav-item" style={{ flexShrink: 0 }}>
                        <Link
                          to="#emp_projects"
                          data-bs-toggle="tab"
                          className="nav-link"
                          style={{
                            padding: "14px 20px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#6b7280",
                            border: "none",
                            borderBottom: "3px solid transparent",
                            whiteSpace: "nowrap",
                            transition: "all 0.2s ease",
                            background: "transparent",
                            marginBottom: "-2px"
                          }}
                          onMouseEnter={(e) => {
                            if (!e.currentTarget.classList.contains('active')) {
                              e.currentTarget.style.color = "rgb(211, 0, 26)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!e.currentTarget.classList.contains('active')) {
                              e.currentTarget.style.color = "#6b7280";
                            }
                          }}
                        >
                          Employment
                        </Link>
                      </li>
                      <li className="nav-item" style={{ flexShrink: 0 }}>
                        <Link
                          to="#emp_assets"
                          data-bs-toggle="tab"
                          className="nav-link"
                          style={{
                            padding: "14px 20px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#6b7280",
                            border: "none",
                            borderBottom: "3px solid transparent",
                            whiteSpace: "nowrap",
                            transition: "all 0.2s ease",
                            background: "transparent",
                            marginBottom: "-2px"
                          }}
                          onMouseEnter={(e) => {
                            if (!e.currentTarget.classList.contains('active')) {
                              e.currentTarget.style.color = "rgb(211, 0, 26)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!e.currentTarget.classList.contains('active')) {
                              e.currentTarget.style.color = "#6b7280";
                            }
                          }}
                        >
                          Assets
                        </Link>
                      </li>
                      <li className="nav-item" style={{ flexShrink: 0 }}>
                        <Link
                          to="#emp_leaves"
                          data-bs-toggle="tab"
                          className="nav-link"
                          style={{
                            padding: "14px 20px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#6b7280",
                            border: "none",
                            borderBottom: "3px solid transparent",
                            whiteSpace: "nowrap",
                            transition: "all 0.2s ease",
                            background: "transparent",
                            marginBottom: "-2px"
                          }}
                          onMouseEnter={(e) => {
                            if (!e.currentTarget.classList.contains('active')) {
                              e.currentTarget.style.color = "rgb(211, 0, 26)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!e.currentTarget.classList.contains('active')) {
                              e.currentTarget.style.color = "#6b7280";
                            }
                          }}
                        >
                          Leave
                        </Link>
                      </li>
                      <li className="nav-item" style={{ flexShrink: 0 }}>
                        <Link
                          to="#emp_documents"
                          data-bs-toggle="tab"
                          className="nav-link"
                          style={{
                            padding: "14px 20px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#6b7280",
                            border: "none",
                            borderBottom: "3px solid transparent",
                            whiteSpace: "nowrap",
                            transition: "all 0.2s ease",
                            background: "transparent",
                            marginBottom: "-2px"
                          }}
                          onMouseEnter={(e) => {
                            if (!e.currentTarget.classList.contains('active')) {
                              e.currentTarget.style.color = "rgb(211, 0, 26)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!e.currentTarget.classList.contains('active')) {
                              e.currentTarget.style.color = "#6b7280";
                            }
                          }}
                        >
                          Documents
                        </Link>
                      </li>
                      <li className="nav-item" style={{ flexShrink: 0 }}>
                        <Link
                          to="#emp_expenses"
                          data-bs-toggle="tab"
                          className="nav-link"
                          style={{
                            padding: "14px 20px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#6b7280",
                            border: "none",
                            borderBottom: "3px solid transparent",
                            whiteSpace: "nowrap",
                            transition: "all 0.2s ease",
                            background: "transparent",
                            marginBottom: "-2px"
                          }}
                          onMouseEnter={(e) => {
                            if (!e.currentTarget.classList.contains('active')) {
                              e.currentTarget.style.color = "rgb(211, 0, 26)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!e.currentTarget.classList.contains('active')) {
                              e.currentTarget.style.color = "#6b7280";
                            }
                          }}
                        >
                          Expenses
                        </Link>
                      </li>
                      {user?.id == userData?.id && (
                        <li className="nav-item" style={{ flexShrink: 0 }}>
                          <Link
                            to="#account_settings"
                            data-bs-toggle="tab"
                            className="nav-link"
                            style={{
                              padding: "14px 20px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#6b7280",
                              border: "none",
                              borderBottom: "3px solid transparent",
                              whiteSpace: "nowrap",
                              transition: "all 0.2s ease",
                              background: "transparent",
                              marginBottom: "-2px"
                            }}
                            onMouseEnter={(e) => {
                              if (!e.currentTarget.classList.contains('active')) {
                                e.currentTarget.style.color = "rgb(211, 0, 26)";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!e.currentTarget.classList.contains('active')) {
                                e.currentTarget.style.color = "#6b7280";
                              }
                            }}
                          >
                            Settings
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                ) : (
                  <div style={{ 
                    overflowX: "auto",
                    overflowY: "hidden",
                    WebkitOverflowScrolling: "touch",
                    scrollbarWidth: "thin",
                    scrollbarColor: "#cbd5e1 transparent"
                  }}>
                    <style>{`
                      .desktop-tabs::-webkit-scrollbar {
                        height: 4px;
                        display: block;
                      }
                      .desktop-tabs::-webkit-scrollbar-track {
                        background: transparent;
                      }
                      .desktop-tabs::-webkit-scrollbar-thumb {
                        background: #cbd5e1;
                        border-radius: 2px;
                      }
                      .desktop-tabs::-webkit-scrollbar-thumb:hover {
                        background: #94a3b8;
                      }
                    `}</style>
                  <ul className="nav nav-tabs nav-tabs-bottom desktop-tabs" style={{
                    borderBottom: "2px solid #e5e7eb",
                    padding: "0",
                    margin: 0,
                    display: "flex",
                    flexWrap: "nowrap",
                    minWidth: "max-content",
                    background: "transparent"
                  }}>
                    <li className="nav-item" style={{ flexShrink: 0 }}>
                      <Link
                        to="#emp_profile"
                        data-bs-toggle="tab"
                        className="nav-link active"
                        style={{
                          padding: "16px 24px",
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "rgb(211, 0, 26)",
                          border: "none",
                          borderBottom: "3px solid rgb(211, 0, 26)",
                          whiteSpace: "nowrap",
                          transition: "all 0.2s ease",
                          background: "transparent",
                          marginBottom: "-2px"
                        }}
                      >
                        Profile
                      </Link>
                    </li>
                    <li className="nav-item" style={{ flexShrink: 0 }}>
                      <Link
                        to="#emp_projects"
                        data-bs-toggle="tab"
                        className="nav-link"
                        style={{
                          padding: "16px 24px",
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#6b7280",
                          border: "none",
                          borderBottom: "3px solid transparent",
                          whiteSpace: "nowrap",
                          transition: "all 0.2s ease",
                          background: "transparent",
                          marginBottom: "-2px"
                        }}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.classList.contains('active')) {
                            e.currentTarget.style.color = "rgb(211, 0, 26)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.classList.contains('active')) {
                            e.currentTarget.style.color = "#6b7280";
                          }
                        }}
                      >
                        Employment
                      </Link>
                    </li>
                    <li className="nav-item" style={{ flexShrink: 0 }}>
                      <Link
                        to="#emp_assets"
                        data-bs-toggle="tab"
                        className="nav-link"
                        style={{
                          padding: "16px 24px",
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#6b7280",
                          border: "none",
                          borderBottom: "3px solid transparent",
                          whiteSpace: "nowrap",
                          transition: "all 0.2s ease",
                          background: "transparent",
                          marginBottom: "-2px"
                        }}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.classList.contains('active')) {
                            e.currentTarget.style.color = "rgb(211, 0, 26)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.classList.contains('active')) {
                            e.currentTarget.style.color = "#6b7280";
                          }
                        }}
                      >
                        Assets
                      </Link>
                    </li>
                    <li className="nav-item" style={{ flexShrink: 0 }}>
                      <Link
                        to="#emp_leaves"
                        data-bs-toggle="tab"
                        className="nav-link"
                        style={{
                          padding: "16px 24px",
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#6b7280",
                          border: "none",
                          borderBottom: "3px solid transparent",
                          whiteSpace: "nowrap",
                          transition: "all 0.2s ease",
                          background: "transparent",
                          marginBottom: "-2px"
                        }}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.classList.contains('active')) {
                            e.currentTarget.style.color = "rgb(211, 0, 26)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.classList.contains('active')) {
                            e.currentTarget.style.color = "#6b7280";
                          }
                        }}
                      >
                        Leave
                      </Link>
                    </li>
                    <li className="nav-item" style={{ flexShrink: 0 }}>
                      <Link
                        to="#emp_documents"
                        data-bs-toggle="tab"
                        className="nav-link"
                        style={{
                          padding: "16px 24px",
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#6b7280",
                          border: "none",
                          borderBottom: "3px solid transparent",
                          whiteSpace: "nowrap",
                          transition: "all 0.2s ease",
                          background: "transparent",
                          marginBottom: "-2px"
                        }}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.classList.contains('active')) {
                            e.currentTarget.style.color = "rgb(211, 0, 26)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.classList.contains('active')) {
                            e.currentTarget.style.color = "#6b7280";
                          }
                        }}
                      >
                        Documents
                      </Link>
                    </li>
                    <li className="nav-item" style={{ flexShrink: 0 }}>
                      <Link
                        to="#emp_expenses"
                        data-bs-toggle="tab"
                        className="nav-link"
                        style={{
                          padding: "16px 24px",
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#6b7280",
                          border: "none",
                          borderBottom: "3px solid transparent",
                          whiteSpace: "nowrap",
                          transition: "all 0.2s ease",
                          background: "transparent",
                          marginBottom: "-2px"
                        }}
                        onMouseEnter={(e) => {
                          if (!e.currentTarget.classList.contains('active')) {
                            e.currentTarget.style.color = "rgb(211, 0, 26)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!e.currentTarget.classList.contains('active')) {
                            e.currentTarget.style.color = "#6b7280";
                          }
                        }}
                      >
                        Expenses
                      </Link>
                    </li>
                    {user?.id == userData?.id && (
                      <li className="nav-item" style={{ flexShrink: 0 }}>
                        <Link
                          to="#account_settings"
                          data-bs-toggle="tab"
                          className="nav-link"
                          style={{
                            padding: "16px 24px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#6b7280",
                            border: "none",
                            borderBottom: "3px solid transparent",
                            whiteSpace: "nowrap",
                            transition: "all 0.2s ease",
                            background: "transparent",
                            marginBottom: "-2px"
                          }}
                          onMouseEnter={(e) => {
                            if (!e.currentTarget.classList.contains('active')) {
                              e.currentTarget.style.color = "rgb(211, 0, 26)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!e.currentTarget.classList.contains('active')) {
                              e.currentTarget.style.color = "#6b7280";
                            }
                          }}
                        >
                          Account Settings
                        </Link>
                      </li>
                    )}
                  </ul>
                  </div>
                )}
                <style>{`
                  .nav-tabs {
                    border-bottom: none !important;
                  }
                  .nav-tabs .nav-link {
                    position: relative;
                    border: none !important;
                  }
                  .nav-tabs {
                    border-bottom: 2px solid #e5e7eb !important;
                  }
                  .nav-tabs .nav-link.active {
                    color: rgb(211, 0, 26) !important;
                    border-bottom: 3px solid rgb(211, 0, 26) !important;
                    background: transparent !important;
                  }
                  .nav-tabs .nav-link:not(.active) {
                    color: #6b7280 !important;
                    background: transparent !important;
                    border-bottom: 3px solid transparent !important;
                  }
                  .nav-tabs .nav-link:hover:not(.active) {
                    color: rgb(211, 0, 26) !important;
                    background: transparent !important;
                  }
                  .nav-tabs .nav-link:focus {
                    outline: none;
                    box-shadow: none;
                  }
                `}</style>
              </div>
            </div>
          )}

          {/* Error full page */}
          {!detailLoading && detailError && (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "70vh", padding: "16px" }}>
              <div className="card shadow-sm" style={{ maxWidth: "520px", width: "100%" }}>
                <div className="card-body text-center">
                  <i className="las la-exclamation-triangle" style={{ fontSize: "36px", color: "#d3001a" }} />
                  <h5 style={{ marginTop: "10px" }}>
                    {detailError === "not_found" ? "Employee not found or access denied." : "Unable to load employee details."}
                  </h5>
                  <p style={{ color: "#6b7280" }}>Please go back or open the employee listing.</p>
                  <div className="d-flex justify-content-center" style={{ gap: "10px" }}>
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={handleClickGoBack}
                    >
                      Go Back
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => navigate("/employees")}
                    >
                      Employee Listing
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Show profile tab component only when not loading and no error */}
          {!detailLoading && !detailError && (
            <div style={isMobile ? { padding: "0", background: "#f9fafb" } : { padding: "0", background: "transparent" }}>
              <ProfileTab
                fetchAddresses={fetchAddresses}
                userData={userData}
                userSalaryData={userSalaryData}
                addressData={addresses}
                addressLoading={addressLoading}
                fetchDetail={fetchDetail}
                allowedEmployeeIds={allowedEmployeeIds}
                showOrgChart={false}
              />
            </div>
          )}

          <ChangePictureModal
            show={pictureModal}
            handleClose={() => setPictureModal(false)}
            currentImage={userData?.profile_image}
            id={userData?.id}
            changeImage={changeImage}
          />
        </div>
      </div>
    </>
  );
};

export default Profile;

